import { Box, Link, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import { makeStyles } from "@material-ui/core";
import { BiArrowBack } from "react-icons/bi";
import Slider from "./Slider";

let sliderNumber = 1;

const Available = ({
  setAvailable,
  setShowForm,
  optimalPlans,
  setNotAvailable,
  setOptimalPlan,
  setUserInfo,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: "#009A88",
    whiteSpace: "nowrap",
  }));

  return (
    <Box m="10% 10% 10% 10%">
      <Slider
        optimalPlans={optimalPlans}
        setNotAvailable={setNotAvailable}
        setAvailable={setAvailable}
      />
      <BiArrowBack
        onClick={() => {
          setShowForm(false);
          setAvailable(false);
          setOptimalPlan([]);
          setUserInfo({});
        }}
        className={classes.back}
        size="40px"
        color="#009A88"
      />
    </Box>
  );
};

export default Available;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #009A88",
    color: "#fff",
    "&:hover": {
      background: "transparent",
      animation: "$scale .2s ease-in-out",
      color: "#009A88",
    },
  },
  back: {
    position: "absolute",
    top: "15%",
    left: "5%",
    cursor: "pointer",
  },
  leftarrow: { marginRight: "20px", cursor: "pointer" },
  rightarrow: { marginLeft: "20px", cursor: "pointer" },
  "@keyframes scale": {
    "0%": {
      transform: "scale(1, 1)",
      //animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
